const NON_ALPHANUMERIC_REGEX = /[^a-z0-9-]/gi

export const removeNonAlphanumeric = (str: string) =>
  str.toLowerCase().trim().replace(/ /g, '-').replace(NON_ALPHANUMERIC_REGEX, '')
